import { SetStateAction, useState } from "react";
import { Button } from "@mui/material";
import "../Main.css";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import {
  ChallengeFeatures,
  ChallengeTagline,
  ChallengeQrCard,
} from "./ChallengeSlide";

const Hero1 = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
    beforeChange: (_: any, next: SetStateAction<number>) =>
      setActiveSlide(next),
  };

  const data = [
    {
      baseImg: "/assets/home banner/himsV.webp",
      mainImg: "/assets/home banner/hims.webp",
      shapeColor: "#4DB6AC",
      span1: "We Build",
      span2: "Smart Healthcare Solutions",
      para: "Digitize hospital operations with our advanced HIMS & EMR systems for seamless patient care and management.",
    },
    {
      baseImg: "/assets/home banner/payplusV.webp",
      mainImg: "/assets/home banner/payplus.webp",
      shapeColor: "#1784A2",
      span1: "We Provide",
      span2: "Simplified Payroll Management",
      para: "Boost your business with intelligent CRM solutions designed to enhance engagement and drive growth.",
    },
    {
      baseImg: "/assets/home banner/solarV.webp",
      mainImg: "/assets/home banner/solar.webp",
      shapeColor: "#FF7029",
      span1: "We Provide",
      span2: "Empower Customer Relationships",
      para: "Boost your business with intelligent CRM solutions designed to enhance engagement and drive growth.",
    },
    {
      baseImg: "",
      mainImg: "/assets/home banner/chennai.png",
      shapeColor: "#E2D100",
      span1: "Chennai",
      span2: "Challenge Us!",
      para: "Think your business deserves a world-class website?",
      challenge: true,
    },
  ];

  return (
    <section
      className="main-bg position-relative"
      style={{ overflow: "hidden" }}
    >
      <Slider {...settings}>
        {data.map((item, index) => (
          <div key={index}>
            <motion.div
              className="bg-spring"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: activeSlide === index ? 1 : 0, y: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div className="row">
                <motion.div
                  className="col-lg-6 col-sm-6 col-md-6 col-6 d-flex justify-content-center align-items-center"
                  initial={{ x: -100, opacity: 0 }}
                  animate={{ x: 0, opacity: activeSlide === index ? 1 : 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                >
                  <div className={`bannerMain${item.challenge ? " challenge-slide" : ""}`}>
                    <h1>
                      <motion.span
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: activeSlide === index ? 1 : 0,
                          y: 0,
                        }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                      >
                        {item.span1}
                      </motion.span>
                      <br />
                      <motion.span
                        initial={{ opacity: 0, y: -20 }}
                        animate={{
                          opacity: activeSlide === index ? 1 : 0,
                          y: 0,
                        }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                        style={{
                          color:
                            index === 0
                              ? "#4DB6AC"
                              : index === 1
                              ? "#1784A2"
                              : index === 2
                              ? "#FF7029"
                              : "#000",
                        }}
                      >
                        {item.span2}
                      </motion.span>
                    </h1>
                    <motion.p
                      initial={{ opacity: 0 }}
                      animate={{ opacity: activeSlide === index ? 1 : 0 }}
                      transition={{ duration: 0.7, delay: 0.6 }}
                    >
                      {item.para}
                    </motion.p>
                    {item.challenge && (
                      <>
                        <ChallengeFeatures />
                        <ChallengeTagline />
                      </>
                    )}
                    <motion.div
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{
                        opacity: activeSlide === index ? 1 : 0,
                        scale: 1,
                      }}
                      transition={{ duration: 0.5, delay: 0.8 }}
                    >
                      <Link to="/contact-us">
                      <Button variant="contained">
                        {item.challenge ? "Book Now" : "Get In Touch"}
                      </Button>
                      </Link>
                    </motion.div>
                  </div>
                  {item.challenge && <ChallengeQrCard />}
                </motion.div>

                <motion.div
                  className="col-lg-6 col-md-6 col-sm-6 col-6 p-0"
                  initial={{ x: 100, opacity: 0 }}
                  animate={{ x: 0, opacity: activeSlide === index ? 1 : 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                >
                  <div className="image-wrapper">
                    {item.shapeColor ? (
                    <motion.div
                      className="base-img tinted-shape"
                      aria-hidden="true"
                      style={{
                        backgroundColor: item.shapeColor,
                        WebkitMaskImage: 'url("/assets/home banner/himsV.webp")',
                        maskImage: 'url("/assets/home banner/himsV.webp")',
                      }}
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{
                        scale: activeSlide === index ? 1 : 0.8,
                        opacity: activeSlide === index ? 1 : 0,
                      }}
                      transition={{ duration: 0.5, delay: 0.5 }}
                    />
                    ) : (
                    <motion.img
                      src={item.baseImg}
                      className="img-fluid base-img"
                      style={{right:"0px", display:"flex", top:"0px"}}
                      loading="lazy"
                      alt="Base Image"
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{
                        scale: activeSlide === index ? 1 : 0.8,
                        opacity: activeSlide === index ? 1 : 0,
                      }}
                      transition={{ duration: 0.5, delay: 0.5 }}
                    />
                    )}
                    <motion.img
                      src={item.mainImg}
                      className="img-fluid overlay-img" style={{right:"0px !important"}}
                      loading="lazy"
                      alt="Overlay Image"
                   initial={{ scale: 0.8, opacity: 0 }}
                      animate={{
                        scale: activeSlide === index ? 1 : 0.8,
                        opacity: activeSlide === index ? 1 : 0,
                      }}
                      transition={{ duration: 0.5, delay: 0.7 }}
                    />
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        ))}
      </Slider>

      <motion.img
        src="/assets/home banner/bannerBG.webp"
        className="img-fluid spring-img"
        alt="spring-img"
        loading="lazy"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.9 }}
      />
    </section>
  );
};

export default Hero1;
